import { ArrowLeft, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface Props {
  onBack: () => void
  showBack: boolean
  onContinue: () => void
  continueLabel?: string
  continueLoading?: boolean
  continueDisabled?: boolean
  onSkip?: () => void
}

const StepFooter = ({
  onBack,
  showBack,
  onContinue,
  continueLabel = 'Continue',
  continueLoading = false,
  continueDisabled = false,
  onSkip,
}: Props) => {
  return (
    <div className='mt-8 flex items-center justify-between gap-2'>
      <Button
        type='button'
        variant='ghost'
        onClick={onBack}
        className={showBack ? 'gap-2' : 'invisible'}
      >
        <ArrowLeft className='h-4 w-4' />
        Back
      </Button>

      <div className='flex items-center gap-2'>
        {onSkip ? (
          <Button type='button' variant='ghost' onClick={onSkip}>
            Skip
          </Button>
        ) : null}
        <Button
          type='button'
          onClick={onContinue}
          loading={continueLoading}
          disabled={continueDisabled}
          className='gap-2 w-30'
        >
          {continueLabel}
          <ArrowRight className='h-4 w-4' />
        </Button>
      </div>
    </div>
  )
}

export default StepFooter
